import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const controlStyles = css`
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(0.75)} ${theme.spacing(1)};
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  cursor: pointer;
`;

export const IconButtonStyles = css`
  background: transparent;
  padding: 0;
  height: fit-content;
  &:hover {
    background: transparent;
  }
`;

export const MIN_RANGE_VALUE = 1;
export const MAX_RANGE_VALUE = 100;
export const STEP = 25;

export const WIDTH_OFFSET_LARGE_DEVICE = '80px';
export const WIDTH_OFFSET_SMALL_DEVICE = '12px';
